import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  IconButton,
  Input,
  Option,
  Select,
  Tooltip,
  Typography,
} from '@material-tailwind/react';
import { getCookie } from '../../../../utils/helper';
import { useEffect, useState } from 'react';
import {
  addPhuongGroup,
  listAllPhuongGroup,
  listAllStreets,
  listCountAllPhuongGroup,
  listIdPhuongGroup,
  listPhuongGroupWhere,
  removePhuongGroup,
  updatePhuongGroup,
} from '../../../../services/apiCategory';
import { ChevronDownIcon, ChevronUpIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/solid';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const TABLE_HEAD = ['Xã/Phường Mới', 'Xã/Phường Cũ', ''];

export default function PhuongGroup() {
  const auth = getCookie('token');
  const [resultList, setResultList] = useState([]);
  const [arrOptionSelect, setArrOptionSelect] = useState({});
  const [arrOptionSelectSearch, setArrOptionSelectSearch] = useState({});
  const [arrDefault, setArrDefault] = useState({ id_user: auth?.id, phuong_group: '', huyen: '', xa_old: '' });
  const [isDisabled, setIsDisabled] = useState(false);
  const [open, setOpen] = useState(0);
  const [message, setMessage] = useState('');
  const [messageError, setMessageError] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [page, setPage] = useState(1);
  const [countDefault, setCountDefault] = useState(0);
  const [checkInfo, setCheckInfo] = useState(false);
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const idCate = urlParams.get('u');
  const navigate = useNavigate();

  const listAll = async (pages = 1) => {
    const resultAPI = await listAllPhuongGroup(pages);
    if (resultAPI.length > 0) {
      setResultList(resultAPI);
      const count = await listCountAllPhuongGroup();
      setCountDefault(count.totalRows);
    }
  };

  const handleSearchOptionSelect = (key, val, keysearch) => {
    if (val) {
      const results = arrOptionSelect[key].filter((item) => item[keysearch].toLowerCase().includes(val.toLowerCase()));
      setArrOptionSelectSearch({ ...arrOptionSelect, [key]: results });
    } else {
      setArrOptionSelectSearch({ ...arrOptionSelect, [key]: arrOptionSelect[key] });
    }
  };

  const uniqueData = (data, key) => {
    const seen = new Set();

    const cleaned = data
      .map((item) => {
        let val = item[key];
        if (!val) return null; // bỏ null, undefined
        val = String(val).trim().replace(/\s+/g, ' '); // bỏ khoảng trắng thừa
        return { ...item, [key]: val };
      })
      .filter((item) => item && item[key] !== ''); // bỏ rỗng sau khi clean

    const unique = cleaned.filter((item) => {
      const val = item[key].toLowerCase();
      if (seen.has(val)) return false;
      seen.add(val);
      return true;
    });

    // sắp xếp theo số trong chuỗi
    unique.sort((a, b) => {
      const numA = parseInt(a[key].match(/\d+/)?.[0] || 0, 10);
      const numB = parseInt(b[key].match(/\d+/)?.[0] || 0, 10);
      return numB - numA;
    });

    return unique;
  };

  const getStreets = async () => {
    const resultAPI = await listAllStreets(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, streets: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, streets: resultAPI });
    }
  };

  useEffect(() => {
    document.title = 'Danh mục địa điểm';
    listAll(1);
    getStreets();
  }, []);

  useEffect(() => {
    getListID(idCate);
  }, [idCate]);

  const getListID = async (id) => {
    if (id) {
      const resultID = await listIdPhuongGroup(idCate);
      if (resultID.length > 0) {
        setCheckInfo(true);
        setArrDefault({
          id_user: auth?.id,
          phuong_group: resultID[0].phuong_group,
          huyen: resultID[0].huyen,
          xa_old: resultID[0].xa_old,
        });
      } else {
        setCheckInfo(false);
      }
    }
  };

  const changeValueAdmin = (jsonVL) => {
    setArrDefault({ ...arrDefault, ...jsonVL });
  };

  const subAddDefault = async () => {
    if (arrDefault?.xa_old === '' || arrDefault?.phuong_group === '') {
      setMessageError(
        'Bạn nhập thiếu thông tin. Hãy nhập đầy đủ \n (Viết Hoa Chữ Cái Đầu -> ví dụ: Cam Ly - Hồ Xuân Hương)',
      );
    } else {
      const checkTrung = await listPhuongGroupWhere(arrDefault?.xa_old, arrDefault?.phuong_group);
      if (checkTrung?.length > 0) {
        setMessageError('Thông tin này đã có trong hệ thống');
      } else {
        setMessageError('');
        setIsDisabled(true);
        const resultAPI = await addPhuongGroup(arrDefault);
        if (resultAPI.message === 'OK') {
          setIsDisabled(false);
          listAll(1);
          setMessage('Thành Công');
          setOpenAlert(true);
          setArrDefault({ id_user: auth?.id, huyen: '', xa_old: '', phuong_group: '' });
        } else {
          setIsDisabled(false);
          setMessage('Thất Bại');
          setOpenAlert(true);
        }
      }
    }
  };
  const subUpdateDefault = async () => {
    if (arrDefault?.xa_old === '' || arrDefault?.phuong_group === '') {
      setMessageError(
        'Bạn nhập thiếu thông tin. Hãy nhập đầy đủ \n (Viết Hoa Chữ Cái Đầu -> ví dụ: Cam Ly - Hồ Xuân Hương)',
      );
    } else {
      setMessageError('');
      setIsDisabled(true);
      const body = {
        id: idCate,
        data: arrDefault,
      };
      const resultAPI = await updatePhuongGroup(body);
      if (resultAPI.message === 'OK') {
        setIsDisabled(false);
        listAll(1);
        navigate('/phuonggroup');
        setMessage('Thành Công');
        setOpenAlert(true);
        setArrDefault({ id_user: auth?.id, huyen: '', xa_old: '', phuong_group: '' });
        setCheckInfo(false);
      } else {
        setIsDisabled(false);
        setMessage('Thất Bại');
        setOpenAlert(true);
      }
    }
  };

  const alertRemove = async (id) => {
    if (window.confirm(`Bạn đã chắc chắn XÓA dữ liệu này?`)) {
      // Save it!
      const body = {
        id: id,
      };
      const resultAPI = await removePhuongGroup(body);
      if (resultAPI?.message === 'OK') {
        listAll(1);
      }
    } else {
      // Do nothing!
      console.log('Hủy yêu cầu');
    }
  };

  const nextPage = () => {
    const total = Math.ceil(countDefault / 50);
    if (total > page) {
      setPage(page + 1);
      listAll(page + 1);
    }
  };

  const prevPage = () => {
    const total = Math.ceil(countDefault / 50);
    if (total <= page && page > 1) {
      setPage(page - 1);
      listAll(page - 1);
    }
  };

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div>
        <Card className="p-2">
          <h3 className="font-bold mb-1">THÊM NHÓM PHƯỜNG MỚI </h3>

          <Alert
            color={message === 'Thành Công' ? 'green' : 'red'}
            className="mb-2"
            open={openAlert}
            onClose={() => setOpenAlert(false)}
          >
            {message === 'Thành Công' ? 'Cập Nhật Thành Công' : 'Cập Nhật Thất Bại'}
          </Alert>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="relative">
              <button
                className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                onClick={() => {
                  handleOpen(1);
                  getStreets();
                }}
              >
                <span className="mr-2">{arrDefault && arrDefault.xa_old ? arrDefault.xa_old : 'Chọn Phường / Xã'}</span>

                {open === 1 ? <ChevronUpIcon className="h-5 w-5" /> : <ChevronDownIcon className="h-5 w-5" />}
              </button>
              {open === 1 && (
                <div
                  className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                >
                  <Input
                    // value={}
                    className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                    labelProps={{
                      className: 'hidden',
                    }}
                    onChange={(e) => handleSearchOptionSelect('streets', e.target.value, 'xa')}
                  />

                  <div className="pl-1">
                    <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                  </div>
                  {arrOptionSelectSearch?.streets &&
                    uniqueData(arrOptionSelectSearch?.streets, 'xa')?.map((row, index) => (
                      <div
                        className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                        key={index}
                        onClick={() => {
                          setArrDefault({ ...arrDefault, huyen: row?.huyen, xa_old: row?.xa });
                          handleOpen(0);
                          handleSearchOptionSelect('streets', row?.xa, 'xa');
                          //   setIsChangeData({ ...isChangeData, huyện: row?.huyen });
                        }}
                      >
                        {row?.xa},{row?.huyen}
                      </div>
                    ))}
                </div>
              )}
            </div>

            <div>
              <Input
                value={arrDefault?.phuong_group}
                label="Tên Phường/ Xã Mới"
                placeholder="Nhập tên Phường/ Xã Mới"
                required
                onChange={(e) => {
                  changeValueAdmin({ phuong_group: e.target.value });
                }}
              />
            </div>
          </div>
          {messageError && <b className="text-red-500"> {messageError}</b>}
          <Button
            className="bg-gradient-to-r from-orange-400 to-orange-900 mt-2"
            onClick={checkInfo ? subUpdateDefault : subAddDefault}
            disabled={isDisabled}
          >
            {checkInfo ? 'CẬP NHẬT' : 'LƯU THÊM MỚI'}
          </Button>

          <p className="text-red-500 font-bold">
            Lưu ý: Nhập viết chữ hoa đầu và không ghi chữ Phường/Xã: ví dụ Phường Lâm Viên {`->`} Lâm Viên, Xã Nam Ban{' '}
            {`->`} Nam Ban ( chỉ ghi Phường nếu là số: Ví dụ Phường 1, Phường 2)
          </p>
        </Card>
      </div>
      <div>
        <Card className="h-full w-full">
          <CardBody className="overflow-auto px-0 p-1 rounded-3xl">
            <table className="w-full min-w-max table-auto text-left">
              <thead>
                <tr>
                  {TABLE_HEAD.map((head) => (
                    <th key={head} className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                      <Typography variant="small" color="blue-gray" className="font-normal leading-none opacity-70">
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {resultList.map((row, index) => {
                  const isLast = index === resultList.length - 1;
                  const classes = isLast ? 'p-4' : 'p-4 border-b border-blue-gray-50';

                  return (
                    <tr key={index}>
                      <td className={classes}>
                        <Typography variant="small" color="blue-gray" className="font-normal">
                          {row.phuong_group}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography variant="small" color="blue-gray" className="font-normal">
                          {row.xa_old}, {row.huyen}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Tooltip content="Sửa">
                          <Link to={`/phuonggroup?u=${row.id}`}>
                            <IconButton variant="text">
                              <PencilIcon className="h-4 w-4" />
                            </IconButton>
                          </Link>
                        </Tooltip>

                        <Tooltip content={`Xóa`}>
                          <IconButton variant="text" onClick={() => alertRemove(row.id)}>
                            <TrashIcon className={`h-4 w-4 text-red-500`} />
                          </IconButton>
                        </Tooltip>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </CardBody>
          {Math.ceil(countDefault / 50) > page && (
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Typography variant="small" color="blue-gray" className="font-normal">
                Page {page} of {Math.ceil(countDefault / 50)}
              </Typography>
              <div className="flex gap-2">
                <Button variant="outlined" size="sm" onClick={prevPage}>
                  Trang Trước
                </Button>
                <Button variant="outlined" size="sm" onClick={nextPage}>
                  Trang Tiếp
                </Button>
              </div>
            </CardFooter>
          )}
        </Card>
      </div>
    </div>
  );
}
